module.exports = __webpack_public_path__ + "static/media/image3.310cc16d.png";